<template>
  <div>
    <div class="header">
      <div class="search" style="width: 60%">
        <el-input
          class="search-input"
          style="width: 200px"
          v-model="name"
          placeholder="请输入要查询关键字"
        ></el-input>

        <el-button icon="el-icon-search" size="small" @click="onSearch"
          >查询</el-button
        >
        <el-button size="small" @click="onRefresh" icon="el-icon-refresh"
          >刷新</el-button
        >
      </div>
      <div>
        <el-button-group>
          <PermissionsBtn
            :icon="'el-icon-download'"
            :permissionName="'_Export'"
            :btnType="'primary'"
            :downloadUrl="'/productAdmin/Ad/downLoad_position'"
            :checkList="checkList"
            :form="{ name: this.name }"
          ></PermissionsBtn>
          <el-button
            style="margin: 0 10px"
            type="primary"
            icon="el-icon-plus"
            @click="onAdd"
            v-if="roleList[path].includes('_Add')"
            >新增</el-button
          >
        </el-button-group>
      </div>
    </div>

    <el-table
      v-loading="listLoading"
      :data="tableData"
      element-loading-text="Loading"
      border
      @selection-change="handleSelectionChange"
      fit
      highlight-current-row
    >
      <el-table-column type="selection" width="55"> </el-table-column>
      <el-table-column align="center" width="50" label="编号">
        <template slot-scope="scope">
          {{ scope.$index + 1 }}
        </template>
      </el-table-column>

      <el-table-column label="位置名称" width="150" align="center">
        <template slot-scope="scope">
          {{ scope.row.name }}
        </template>
      </el-table-column>

      <el-table-column label="宽度" width="100" align="center">
        <template slot-scope="scope">
          {{ scope.row.width }}
        </template>
      </el-table-column>

      <el-table-column label="高度" width="100" align="center">
        <template slot-scope="scope">
          <span>{{ scope.row.height }}</span>
        </template>
      </el-table-column>

      <el-table-column class-name="status-col" label="类型" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.type === 1 ? 'success' : 'info'">{{
            scope.row.type | globalStatusFilter
          }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="100" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="mini"
            @click="edit(scope)"
            v-if="roleList[path].includes('_Update')"
            >编辑</el-button
          >
          <el-button
            type="text"
            size="mini"
            @click="deleteItem(scope)"
            v-if="roleList[path].includes('_Delete')"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 修改表单对话框 -->
    <editForm ref="editForm" />
  </div>
</template>

<script>
const editForm = () => import('./editForm'); // 表单
import { mapGetters } from 'vuex';
import { positionRemove, positionList } from '@/api/bannerApi.js';
const globalStatus = [
  {
    type: 1,
    name: '图片',
  },
  {
    type: 2,
    name: '其他',
  },
];
export default {
  components: {
    editForm,
  },
  inject: ['reload'],
  computed: {
    ...mapGetters(['roleList']),
  },
  created() {
    const arr = this.$route.path.split('/');
    this.path = arr[arr.length - 1];
  },
  mounted() {
    // this.listLoading = true
    this.getList();
  },
  data() {
    return {
      path: '',
      listLoading: false,
      tableData: [],
      name: '',
      checkList: [], // 选中的列表
    };
  },
  beforeCreate() {},
  filters: {
    globalStatusFilter(type) {
      // 全局的 globalStatus , 返回一个满足条件的对象
      const obj = globalStatus.find((obj) => obj.type === type);
      // 非空返回对应的名称
      return obj ? obj.name : null;
    },
  },
  watch: {},
  methods: {
    // 获取数据的方法
    getList() {
      positionList({
        name: this.name,
      }).then((res) => {
        this.tableData = res.data.adPositions;
        this.listLoading = false;
      });
    },
    // 搜索
    onSearch() {
      this.getList();
    },
    handleSelectionChange(val) {
      this.checkList = val.map((item) => {
        return item.positionId;
      });
    },
    // 刷新当前页面
    onRefresh() {
      this.reload();
    },

    // 增加
    onAdd() {
      this.$refs.editForm.positionId = '';
      this.$refs.editForm.dialogTitle = '新增广告位';
      this.$refs.editForm.dialogFormVisible = true;
    },
    // 单条编辑
    edit(scope) {
      this.$refs.editForm.positionId = scope.row.positionId;
      this.$refs.editForm.dialogTitle = '编辑广告位';
      this.$refs.editForm.dialogFormVisible = true;
      this.$refs.editForm.editForm = JSON.parse(JSON.stringify(scope.row));
    },
    // 单条删除
    deleteItem(scope) {
      const item = scope.row;
      let checkIds = [];
      checkIds.push(item.positionId);
      this.funcRemove(checkIds);
    },
    funcRemove: function (checkIds) {
      try {
        if (checkIds.length === 0)
          return this.$message.error('请选择要删除的数据');
        this.$confirm('是否狠心删除该数据', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'error',
        }).then(async () => {
          await positionRemove(checkIds).then((res) => {
            if (res.code === 200) {
              this.onRefresh();
              this.$message.success('删除成功!');
            } else {
              this.$message.info('删除失败：' + res.message);
            }
          });
        });
      } catch (e) {
        this.$message.info('删除出错:' + e.message);
        window.console.log(e);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;

  .search {
    display: flex;
    width: 800px;

    .search-input {
      margin: 0 10px;
      width: 300px;
    }

    .search-picker {
      width: 250px;
    }

    .search-select {
      margin-right: 10px;
    }
  }

  button {
    height: 40px;
  }
}
.btn {
  display: flex;
  align-items: center;
}
/deep/ .el-checkbox__input {
  margin-left: 10px;
}
</style>
